var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('v-fade-transition',{attrs:{"mode":"out-in"}},[_c('router-view')],1),_c('the-notification')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }